(function() {
  'use strict';

  function init() {
    // Hoofd quantity input (deze wordt door Kaching geüpdatet)
    const mainQtyInput = document.querySelector(
      '.m-product-form__quantity input[name="quantity"], ' +
      '.m-product-form input[name="quantity"], ' +
      '.product-single__quantity input[name="quantity"]'
    );
    
    // Sticky ATC quantity input
    const stickyQtyInputs = document.querySelectorAll(
      '.m-sticky-addtocart  input[name="quantity"], ' +
      '.m-sticky-addtocart  input[name="quantity"], ' +
      'm-sticky-addtocart  input[name="quantity"]'
    );

    if (!mainQtyInput || stickyQtyInputs.length === 0) return;

    console.log(mainQtyInput.value);
    console.log(stickyQtyInputs);

    // Sync helper
    function syncToSticky(value) {
      const qty = parseInt(value, 10);
      if (!qty || qty < 1) return;
      
      stickyQtyInputs.forEach(input => {
        if (parseInt(input.value, 10) !== qty) {
          input.value = qty;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });
    }

    // Initial sync
    syncToSticky(mainQtyInput.value);

    // Listen to changes on main quantity input (Kaching triggert deze)
    mainQtyInput.addEventListener('change', () => syncToSticky(mainQtyInput.value));
    mainQtyInput.addEventListener('input', () => syncToSticky(mainQtyInput.value));

    // Fallback: MutationObserver voor wanneer Kaching de value programmatisch zet
    // zonder events te triggeren
    const observer = new MutationObserver(() => {
      syncToSticky(mainQtyInput.value);
    });
    observer.observe(mainQtyInput, { 
      attributes: true, 
      attributeFilter: ['value'] 
    });

    // Polling fallback voor het geval Kaching alleen .value zet (geen attribute)
    let lastValue = mainQtyInput.value;
    setInterval(() => {
      if (mainQtyInput.value !== lastValue) {
        lastValue = mainQtyInput.value;
        syncToSticky(lastValue);
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();